import { render, staticRenderFns } from "./ApprovalConfigForm.vue?vue&type=template&id=4481161e&scoped=true&"
import script from "./ApprovalConfigForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481161e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4481161e')) {
      api.createRecord('4481161e', component.options)
    } else {
      api.reload('4481161e', component.options)
    }
    module.hot.accept("./ApprovalConfigForm.vue?vue&type=template&id=4481161e&scoped=true&", function () {
      api.rerender('4481161e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/rules/components/approvals/ApprovalConfigForm.vue"
export default component.exports